/**
 * @description HTTP timeout milliseconds
 */
export const TIMEOUT_MILISECONDS = 185000  //3分5秒（185秒）

/**
 * @description BFF リクエスト ベース URL
 */
export const BFF_HTTP_BASE_URL =
  process.env.NODE_ENV === 'local'
    ? 'http://localhost:8080/bff-api'
    : process.env.VUE_APP_BFF_BASE_URL

/**
 * @description 法人 リクエスト アプリケーション ID
 */
export const JURISTIC_PERSON_HTTP_APPLICATION_ID = 'KeMPUP5UGzipE'

/**
 * @description 法人 リクエスト ベース URL
 */
export const JURISTIC_PERSON_HTTP_BASE_URL = `https://api.houjin-bangou.nta.go.jp/4`
